export const pendingUpcomingRaces = (state) => state.upcomingRaces.pending;
export const upcomingRaces = (state) => state.upcomingRaces.races;
export const raceById = (state, raceId) => state.upcomingRaces.races.find((race) => race.id === raceId);
export const registeredHorse = (state, raceId) => { var _a; return (_a = state.upcomingRaces.horsesInRaces.find((item) => item.raceId === raceId)) === null || _a === void 0 ? void 0 : _a.horse; };
export const horsesInRaces = (state) => state.upcomingRaces.horsesInRaces;
export const quickRaces = (state) => state.upcomingRaces.races;
